import { useTranslation } from "react-i18next";
import { Box, Paper, Stack, Typography } from "~/common/mui";

/**
 * Minimal embedded 401 view rendered by the embedded configurator route's error boundary when the
 * partner token is missing, blank, invalid, or expired. Replaces the deleted inline-CSS standalone
 * 401 page; the dead "flag settings missing" branch is intentionally not reproduced.
 *
 * Presentational only: no Redux, no router, no domains. The localized copy is React-owned (chosen
 * from the stable {@code 401} status) with English fallbacks matching the previous JSP. Full backend
 * multi-language localization of the 401 copy is tracked as a follow-up (the storefront translations
 * namespace is build-generated and not editable in this scope).
 */
export function UnauthorizedView() {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: (theme) => theme.spacing(2),
      }}
    >
      <Paper
        elevation={0}
        sx={{
          padding: (theme) => theme.spacing(8),
          maxWidth: 900,
          width: "90%",
          textAlign: "center",
        }}
      >
        <Stack spacing={3} alignItems="center">
          <Typography variant="displaySmall" component="div" sx={{ color: "error.main", fontWeight: 700 }}>
            {t("error.embeddedConfigurator.unauthorized.code", "401")}
          </Typography>
          <Typography variant="headlineMedium" component="h1">
            {t("error.embeddedConfigurator.unauthorized.title", "Unauthorized Access")}
          </Typography>
          <Typography variant="bodyLarge" sx={{ color: "text.secondary" }}>
            {t(
              "error.embeddedConfigurator.unauthorized.message",
              "The token is invalid or has expired. Please generate a new token and try again.",
            )}
          </Typography>
        </Stack>
      </Paper>
    </Box>
  );
}
